const i18n = {
	recallByRegistrator: {
		1 : "Отозвано заявителем",
		0 : "Адклікана заяўнікам"
	},
	basis: {
		1 : "Основание",
		0 : "Падстава"
	},
	recallByRegistratorRequired: {
		1 : "Пожалуйста, добавьте основание.",
		0 : "Калі ласка, дадайце падставу."
	},
	recallByRegistratorSuccess: {
		1 : "Обращение отозвано",
		0 : "Зварот адкліканы"
	},
}

export default i18n
